import React, { Component } from "react";
import { Modal, Button } from "semantic-ui-react";
import cx from "classnames";
import PropTypes from "prop-types";
import { SearchboxWrapper } from "../";
import styles from "./styles.less";
import QueryString from "qs";

class SearchboxModal extends Component {
  componentDidMount() {
    document.addEventListener("click", this.onWindowClick, false);
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.onWindowClick);
  }

  onWindowClick = event => {
    // If the click happened inside the modal, do nothing
    if (event.target.closest("#general-searchbox")) return;
  };

  render() {
    const {
      domainUrl,
      onClose,
      lang,
      isMobileView,
      checkinDate,
      checkoutDate
    } = this.props;
    const modalStyle = {
      background: "transparent"
    };
    const userData = QueryString.parse(window.location.search)["userData"];

    return (
      <Modal
        className={styles.sboxModal}
        style={modalStyle}
        size="mini"
        defaultOpen={true}
        onUnmount={onClose}
      >
        <Button
          className={cx(styles.closeBtn, { [styles.mobileView]: isMobileView })}
          icon="close"
          circular={true}
          onClick={onClose}
          onKeyDown={onClose}
          inverted
        />
        <SearchboxWrapper
          domAttributes={{
            id: "general-searchbox",
            className: styles.searchbox,
            "data-user-data": userData
          }}
          selector="#general-searchbox"
          url={`${domainUrl}?lang=${lang}`}
          enableTitle={false}
          checkinDate={checkinDate}
          checkoutDate={checkoutDate}
        />
      </Modal>
      // </div>
    );
  }
}

SearchboxModal.propTypes = {
  domainUrl: PropTypes.string,
  onClose: PropTypes.func,
  lang: PropTypes.string,
  isMobileView: PropTypes.bool,
  checkinDate: PropTypes.string,
  checkoutDate: PropTypes.string
};

export default SearchboxModal;



// WEBPACK FOOTER //
// ./src/components/SearchboxModal/SearchboxModal.js